import growthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

export const isVisualImprovementsToAuthModalsEnabled = () =>
  growthAcquisitionExperiments.get('enableVisualImprovementsToAuthModals');

export const isProgressiveAuthEnabled = () => growthAcquisitionExperiments.preview('enableProgressiveAuth');

export const shouldUseFullScreenDialog = () => growthAcquisitionExperiments.preview('shouldUseFullScreenDialog');

export const impressIntoProgressiveAuthExperiment = () => growthAcquisitionExperiments.get('enableProgressiveAuth');

export const shouldShowProgressiveAuth = ({
  shouldDisableProgressiveAuth,
}: {
  shouldDisableProgressiveAuth: boolean;
}) => !shouldDisableProgressiveAuth && isProgressiveAuthEnabled();
